import { useId, useState, useSyncExternalStore } from 'react'

const QUERY = '(max-width: 800px)'

function subscribe(onChange) {
  const mq = window.matchMedia(QUERY)
  mq.addEventListener('change', onChange)
  return () => mq.removeEventListener('change', onChange)
}

function getSnapshot() {
  return window.matchMedia(QUERY).matches
}

function getServerSnapshot() {
  return false
}

export function useIsMobileLayout() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}

function Chevron() {
  return (
    <svg className="home-mobile-acc__chevron" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M6 9l6 6 6-6" />
    </svg>
  )
}

/**
 * On viewports up to 800px, children sit behind a closed disclosure.
 * Wider screens render the summary and children in normal flow.
 */
export function HomeMobileAccordion({ summary, children, className = '', summaryOnlyMobile = false }) {
  const mobile = useIsMobileLayout()
  const [open, setOpen] = useState(false)
  if (!mobile) {
    return (
      <div className={className}>
        {summaryOnlyMobile ? null : summary}
        {children}
      </div>
    )
  }
  return (
    <details className={`home-mobile-acc${className ? ` ${className}` : ''}`} onToggle={(event) => setOpen(event.currentTarget.open)}>
      <summary className="home-mobile-acc__summary">
        <span className="home-mobile-acc__label">{summary}</span>
        <Chevron />
      </summary>
      <div className="home-mobile-acc__panel" inert={open ? undefined : true}>
        <div className="home-mobile-acc__panel-inner">{children}</div>
      </div>
    </details>
  )
}

/** Icon and title until clicked, then the description opens in the same card. */
export function AudiencePersonaCard({ icon, title, children }) {
  const [open, setOpen] = useState(false)
  const panelId = useId()
  return (
    <div className={`hero-audience-card audience-persona${open ? ' is-open' : ''}`}>
      <button
        type="button"
        className="audience-persona__btn"
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen((value) => !value)}
      >
        <span className="hero-audience-card__icon-wrap" aria-hidden="true">
          <span className="hero-audience-card__icon">{icon}</span>
        </span>
        <span className="hero-audience-card__label">{title}</span>
      </button>
      <div className="hero-audience-card__text audience-persona__panel" id={panelId} aria-hidden={!open}>
        <div className="audience-persona__panel-inner">{children}</div>
      </div>
    </div>
  )
}
